module.exports = __webpack_public_path__ + "static/media/lock-open.8f944f7d.svg";